import React from 'react';

import Element from '~/src/components/element/Element';
import TickerIcon from '~/src/components/ticker/icon/TickerIcon';
import Ad from '~/src/components/ad/Ad';

import {classNameByType, classNames} from '~/src/utilities/helpers/css';
import {getAdUnitName} from '~/src/utilities/helpers/ad';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {AdTickerEvent} from '~/src/utilities/constants/ad';

import css from './TickerEvent.module.scss';

class TickerEvent extends React.Component {
    hasGameMinute() {
        const data = this.props.data || this.props.Data;
        return data && typeof data.gameMinute === 'number' && data.gameMinute > 0;
    }

    showIconOnTitle() {
        return this.props.type !== 'info' && this.hasGameMinute();
    }

    setIconConfig() {
        const {type, data, Data} = this.props;
        const config = {
            type,
            data: data || Data
        };
        return config;
    }

    getScore() {
        const data = this.props.data || this.props.Data;
        const hasSets = data.sets && data.sets[data.sets.length - 1];
        return data.goals || data.points || data.tiebreak || hasSets;
    }

    getTitle() {
        const score = this.getScore();
        return score ? score.join(' : ') : this.props.title;
    }

    renderElement = (element, index) => {
        const className = classNameByType(css, element.type);

        if (element.type === 'image' && element.image) {
            element.image.maxAspectRatio = parseFloat(css.slideshow);
        }

        return (
            <div key={index} className={className}>
                <Element {...element} meta={this.props.meta} id={this.props.metadataId} />
            </div>
        );
    };

    render() {
        const content = this.props.content;
        const iconConfig = this.setIconConfig();
        const title = this.getTitle();
        const data = this.props.data || this.props.Data;
        const showAd = data && data.timeEvent in AdTickerEvent;
        const className = classNames(css, 'tickerEvent', this.props.type);

        return (
            <React.Fragment>
                {showAd && (
                    <div className={css.ad}>
                        <Ad adUnitName={getAdUnitName('inside-full-content', getNextCounter('inside-full-content'))} />
                    </div>
                )}

                <article className={className}>
                    <div className={css.tickerIconContainer}>
                        <TickerIcon {...iconConfig} showTime={true} tickerType={this.props.tickerType} />
                    </div>
                    {(title || this.showIconOnTitle()) && (
                        <section className={css.tickerEventHeader}>
                            {this.showIconOnTitle() && <TickerIcon {...iconConfig} tickerType={this.props.tickerType} />}
                            {title && <h1>{title}</h1>}
                        </section>
                    )}
                    <section className={css.tickerEventContent}>{content.elements.map(this.renderElement)}</section>
                </article>
            </React.Fragment>
        );
    }
}

export default TickerEvent;
